import styled from 'styled-components';
import Logo from 'components/SvgAssets/MainLogo';

export const FirstRow = styled.div.attrs({
  className: 'PageLoader__FirstRow',
})`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const PageLoaderContainer = styled.div.attrs({
  className: 'PageLoader__Container',
})`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const PageLoaderWrapper = styled.div.attrs({
  className: 'PageLoader__Wrapper',
})`
  margin: 16px;
`;

export const PageLoaderLogo = styled(Logo).attrs({
  className: 'PageLoader__Logo',
})`
  width: 150px;
`;

export const PageLoaderText = styled.h1`
  font-weight: bold;
  font-size: 24px;
  margin: 10px 0 0 0;
  padding: 0;
`;
